import "../../_namespaces.js";
import "../../_generated_templates.js";
import "../response/select_one_choice.js";
import "../response/select_multiple_choice.js";
import "../response/free_text.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.Question = class Question extends Backbone.View {
  constructor() {
    super(...arguments);
    this.render = this.render.bind(this);
    this.renderResponses = this.renderResponses.bind(this);
  }

  // EVENT HANDLERS

  handleResponseExplanationChange(event) {
    const explanation = jQuery(event.currentTarget).val();
    console.log(explanation);
    return this.model.set("response_explanation", explanation);
  }

  // RENDERING

  render() {
    this.$el.append(this.template(this.model.attributes));
    this.renderResponses();
    return this;
  }

  renderResponses() {
    let view;
    switch (this.model.get("responseType")) {
      case "select_one":
        view = new AssessmentViewer.Views.ResponseListSelectOneChoice({
          collection: this.model.get("responses"),
        }).render();
        break;
      case "select_multiple":
        view = new AssessmentViewer.Views.ResponseListSelectMultipleChoice({
          collection: this.model.get("responses"),
        }).render();
        break;
      case "free_text":
        view = new AssessmentViewer.Views.ResponseFreeText({ model: this.model.get("responses").at(0) }).render();
        break;
    }

    return this.$(".responses-container").html(view.el);
  }
};
AssessmentViewer.Views.Question.prototype.tagName = "div";
AssessmentViewer.Views.Question.prototype.className = "assessment-view assessment-view--question";
AssessmentViewer.Views.Question.prototype.template = _.template(AssessmentViewer.Templates.Question.question);
AssessmentViewer.Views.Question.prototype.events = {
  'change [name="response_explanation"]': "handleResponseExplanationChange",
};
